import React from 'react';
import { X } from 'lucide-react';
import './HeroSection.css';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <div className="floating-shape shape-1"></div>
        <div className="floating-shape shape-2"></div>
        <div className="floating-shape shape-3"></div>
      </div>
      
      <div className="hero-content">
        <div className="logo-container">
          <img 
            src="https://customer-assets.emergentagent.com/job_aef2aa9d-1a3c-46d3-9c1b-ca1e22440c7e/artifacts/8ly8rinv_Black%20Red%20Bold%20Minimalist%20Racing%20Gear%20Logo%20%282%29.png" 
            alt="Hosechnopf Logo" 
            className="hero-logo"
          />
        </div>
        
        <div className="announcement-badge">
          <X className="icon-x" size={20} />
          <span>Laden schliesst dauerhaft</span>
        </div>
        
        <h1 className="hero-title">
          Grosser <span className="highlight-yellow">Ausverkauf</span>
        </h1>
        
        <p className="hero-subtitle">
          Nach 48 wundervollen Jahren verabschieden wir uns von euch.
          <br />
          <strong>Alles muss raus!</strong> Kommt vorbei und sichert euch die schönsten Stücke.
        </p>
        
        <div className="info-box">
          <div className="info-item">
            <h3>📍 Vor Ort erhältlich</h3>
            <a 
              href="https://www.google.com/maps/search/?api=1&query=Rathausgasse+37,+5600+Lenzburg" 
              target="_blank" 
              rel="noopener noreferrer"
              className="address-link"
            >
              Rathausgasse 37, 5600 Lenzburg
            </a>
          </div>
          <div className="info-item">
            <h3>🕐 Öffnungszeiten</h3>
            <p className="placeholder-text">Werden noch bekanntgegeben</p>
          </div>
          <div className="info-item">
            <h3>📅 Schließung</h3>
            <p className="placeholder-text">Datum wird noch bekanntgegeben</p>
          </div>
        </div>
        
        <div className="hero-cta">
          <a href="#kollektion" className="cta-button">
            Unsere Kollektion entdecken
          </a>
        </div>
      </div>
      
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;